import { SharePayloadData } from "../types";
import CommonPrefetchedData from "./PrefetchedData/CommonPrefetchedData";
import MemoryOptimizedPrefetchedData from "./PrefetchedData/MemoryOptimizedPrefetchedData";

const queuePrefetchData = (
	data: SharePayloadData,
	prefetched: Record<string, CommonPrefetchedData> = {},
) => {
	const urls = new Set<string>();
	for (const payload of data) {
		if (payload.type === "Image") {
			urls.add(payload.url);
			if (payload.optimizedUrl) {
				urls.add(payload.optimizedUrl);
			}
		}
		if (payload.type === "Video") {
			urls.add(payload.videoUrl);
		}
		if (payload.type === "LivePhoto") {
			urls.add(payload.url);
			urls.add(payload.videoUrl);
			if (payload.optimizedUrl) {
				urls.add(payload.optimizedUrl);
			}
		}
	}
	for (const existingUrl of Object.keys(prefetched)) {
		if (!urls.has(existingUrl)) {
			delete prefetched[existingUrl];
		}
	}

	const urlsArray = Array.from(urls);
	for (let i = 0; i < urlsArray.length; i++) {
		const url = urlsArray[i]!;
		if (!prefetched[url]) {
			prefetched[url] = new MemoryOptimizedPrefetchedData(url, {
				lazy: true,
			});
		}
	}

	return prefetched;
};
export default queuePrefetchData;
